import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {CreateLeadMutation, CustomerDataInputType, LeadDataInputType} from '../../gql/pwa/graphql.ts';
import {Leads} from '../../network/leads.ts';

interface State extends CreateLeadMutation {}
export const createLead = createAsyncThunk(
    'leads/createLead',
    async (data: {
        customerData: CustomerDataInputType[];
        leadData: LeadDataInputType[];
        leadType: string;
        leadProviderId: number;
        customerId: number | null;
    }) => {
        const result = await Leads.createLead(
            data.customerData,
            data.leadData,
            data.leadType,
            data.leadProviderId,
            data.customerId,
        );
        return result.data;
    },
);

export const leadsSlice = createSlice({
    name: 'leadProviders',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(createLead.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(createLead.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.createLead = action.payload?.createLead;
        });
        builder.addCase(createLead.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
